import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import {
  ViewConsentsHistoryCallbackInput,
  ViewConsentsHistoryDialog,
  ViewConsentsHistoryDialogUniqueProps,
} from '../ViewConsentsHistoryDialog';

const { useDialogForContext, useDialog: useViewConsentsHistoryDialog } =
  getDialogHooks<
    ViewConsentsHistoryDialogUniqueProps,
    ViewConsentsHistoryCallbackInput
  >(ViewConsentsHistoryDialog);
export const useViewConsentsHistoryDialogForContenxt = useDialogForContext;
export default useViewConsentsHistoryDialog;
